import React from 'react';
import { Space } from 'antd';
import { Case } from '../../../../services/case';
import CaseBasicInfo from './CaseBasicInfo';
import CaseParties from './CaseParties';

interface CaseInfoTabProps {
  caseData: Case;
  canEdit: boolean;
  onRefresh: () => void;
}

const CaseInfoTab: React.FC<CaseInfoTabProps> = ({ caseData, canEdit, onRefresh }) => {
  return (
    <div className="case-info-tab">
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        {/* Basic Information Card */}
        <CaseBasicInfo caseData={caseData} canEdit={canEdit} onRefresh={onRefresh} />

        {/* Parties Information Card */}
        <CaseParties caseData={caseData} canEdit={canEdit} onRefresh={onRefresh} />
      </Space>
    </div>
  );
};

export default CaseInfoTab;
